import './CurrentWorkspaceRole.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { WorkspaceRole } from '../workspaces.store';

export interface ICurrentWorkspaceRoleProps {
  role?: WorkspaceRole;
}

export const CurrentWorkspaceRole = observer((props: ICurrentWorkspaceRoleProps): ReactElement => {
  const { t } = useTranslator();
  return (
    <div className='top-navigation-workspace-role'>
      {t('your_role')}: {props.role ? t(props.role) : ''}
    </div>
  );
});
